// extracted by mini-css-extract-plugin
export default {"divider":"hjgR4i","buttonContainer":"wT8RHZ","multiPetButton":"leN3pE","multiPetNumInput":"qDiqrs","checkboxContainer":"NSqV63","checkbox":"hjFoAr","copyButton":"l3wWXz"};